import React from 'react';

const QuickSearchInitialTab = ({ sectionList }) => {
  return (
    <div className="absolute left-0 top-28 z-[55] h-screen w-screen border border-solid border-gray-500 bg-white p-4 lg:top-12 lg:h-auto lg:w-max lg:min-w-[50vw] lg:p-8">
      <div className="grid grid-cols-1 sm:grid-cols-2">
        {sectionList.map((listItem, index) => (
          <div
            key={listItem.sectionTitle + index}
            className="flex flex-col"
          >
            <h6 className="uppercase">{listItem.sectionTitle}</h6>
            {listItem.sectionLinkList.map((subListItem, index) => (
              <a
                className="py-1 text-md"
                key={'quick-search-initial' + subListItem.href + index}
                href={subListItem.href}
              >
                {subListItem.text}
              </a>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuickSearchInitialTab;
